import React, { memo, useEffect, useState } from "react"
import SwapPage from "../components/SwapPage"
import SwapForm from "../forms/SwapForm"
import Container from "../components/Container"
import { useSearchParams } from "react-router-dom"
import useMigration from "hooks/useMigration"

export enum Type {
  "SWAP" = "swap",
  "PROVIDE" = "provide",
  "WITHDRAW" = "withdraw",
}

const Swap = () => {
  const { isMigrationPage } = useMigration()
  const [searchParams, setSearchParams] = useSearchParams()

  const type = searchParams.get("type") as Type
  const tabs = {
    tabs: isMigrationPage
      ? [
          {
            name: "migration",
            title: "Migration",
          },
        ]
      : [
          //{ name: Type.SWAP, title: "Stake" },
        ],
    selectedTabName: isMigrationPage ? "migration" : type,
  }

  let [month_apr, setMonth_Apr] = useState(0)
  let [year_apy, setYear_Apy] = useState(0)
  let [biWeek_apr, setBiWeek_Apr] = useState(0)
  let [closePrice_30day, setClosePrice_30day] = useState(0)
  let [closePrice_15day, setClosePrice_15day] = useState(0)

  const handleCurrentPriceChange = (currentPrice: number) => {
    // Do something with the currentPrice in the parent component
    console.log("Updated currentPrice in parent:", currentPrice)

    if (currentPrice !== 0) {
      const calculatedMonthApr = (currentPrice / closePrice_30day - 1) * 100
      const calculatedBiWeekApr = (currentPrice / closePrice_15day - 1) * 100

      setMonth_Apr(calculatedMonthApr)
      setBiWeek_Apr(calculatedBiWeekApr)

      let maxApr
      if (calculatedMonthApr > calculatedBiWeekApr) {
        maxApr = calculatedMonthApr
        setYear_Apy(maxApr * 12)
      } else {
        maxApr = calculatedBiWeekApr
        setYear_Apy(maxApr * 26)
      }
    }
  }

  const handleClosePriceChange_30day = (closePrice_30day: number) => {
    // Do something with the closePrice in the parent component
    console.log("Updated closePrice in parent:", closePrice_30day)
    setClosePrice_30day(closePrice_30day)
  }

  const handleClosePriceChange_15day = (closePrice_15day: number) => {
    // Do something with the closePrice in the parent component
    console.log("Updated closePrice in parent:", closePrice_15day)
    setClosePrice_15day(closePrice_15day)
  }

  useEffect(() => {
    if (!isMigrationPage) {
      if (
        !type ||
        !Object.keys(Type)
          .map((key) => Type[key as keyof typeof Type])
          .includes(type)
      ) {
        searchParams.set("type", Type.SWAP)
        setSearchParams(searchParams, { replace: true })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, isMigrationPage])

  return (
    <Container>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          height: "20px",
          fontSize: "48px",
        }}
      >
        <h1 style={{ color: "#003300" }}>uLP Staking</h1>
        {/*<p style={{ color: 'darkgreen', fontWeight: 'bold', fontSize: '24px' }}>1:1 Exchange</p>*/}
        <a href="https://www../" className="main-header-navbar__nav__link">
          {/*________*/}
        </a>
      </div>

      <br></br>

      <SwapPage
        onCurrentPriceChange={handleCurrentPriceChange}
        onClosePriceChange_30day={handleClosePriceChange_30day}
        onClosePriceChange_15day={handleClosePriceChange_15day}
      >
        <>{type && <SwapForm type={type} tabs={tabs} />}</>
      </SwapPage>
    </Container>
  )
}

export default memo(Swap)
